export default {
    theme: 'black',
    toogle: {
        normal: process.env.BASE_URL + 'static/images/header/owner.png',
        hover: process.env.BASE_URL + 'static/images/header/owner-hover.png',
        active: process.env.BASE_URL + 'static/images/header/owner-active.png',
    },
    title: 'myTools.title',
    tools: '$store.state.tools',
    mppingImg: {
        "rms_user": process.env.BASE_URL + 'static/images/header/gra-my-tools-d-rms.png',
        "codeLab" : process.env.BASE_URL + 'static/images/header/gra-my-tools-d-codelab.png',
        "contentEditor": process.env.BASE_URL + 'static/images/header/gra-my-tools-d-contenteditor.png',
        "customAISkill": process.env.BASE_URL + 'static/images/header/gra-my-tools-d-trainkit.png'
    }
}
